const registerRetellCall = async (agentId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/register-web-call`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          agent_id: agentId
        })
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    throw err;
  }
};

export default registerRetellCall;
